import { Component, inject, Input, OnInit } from '@angular/core';
import { SortDirectionChangeEvent, TableBaseData, TableColumn } from '@eg/ui';
import { UntilDestroy } from '@ngneat/until-destroy';
import { QuickFiltersService } from '../service/quick-filters.service';

@UntilDestroy()
@Component({
  selector: 'rmb-quick-filters-table',
  templateUrl: './quick-filters-table.component.html',
  styleUrls: ['./quick-filters-table.component.scss'],
  standalone: false,
})
export class QuickFiltersTableComponent<T = unknown> implements OnInit {
  private quickFiltersService = inject(QuickFiltersService);

  @Input() store: any;
  @Input() context: string;
  @Input() query: any;
  @Input() filtersList: T[] = [];
  @Input() columns: TableColumn<TableBaseData>[];
  @Input() filters: T[];

  async ngOnInit(): Promise<void> {
    if (this.context && this.store) {
      await this.quickFiltersService.getFiltersList(this.context, this.store);
    }
  }

  sortChange(event: SortDirectionChangeEvent<T>) {
    this.quickFiltersService.sorting(event, this.query, this.store);
  }
}
